/** @var { BlogState } */
const STATE = {
    data: null,
    // baseUrl: "http://localhost:8000/api/",
    categories: {},
    blogs: []
};

export default STATE;
